// frontend/src/i18n.ts

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslation from './locales/en/translation.json';
import ptBRTranslation from './locales/pt-BR/translation.json';
import esLATranslation from './locales/es-LA/translation.json';

const resources = {
  en: {
    translation: enTranslation,
  },
  'pt-BR': {
    translation: ptBRTranslation,
  },
  'es-LA': {
    translation: esLATranslation,
  },
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false, // React already escapes
    },

    detection: {
      // Order of detection
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Keys to lookup language from
      lookupLocalStorage: 'sledex_language',
      // Cache user language
      caches: ['localStorage'],
    },
  });

export default i18n;
